import * as React from 'react';
import type { SVGProps } from 'react';
const IconCircleTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconCircleTick"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m3.985 3.621L17.4 9.036 11.035 15.4 7.5 11.864l1.414-1.414 2.122 2.121z"
    />
  </svg>
);
export default IconCircleTick;
